import { action } from '@ember/object'
import Component from '@glimmer/component'
import { tracked } from '@glimmer/tracking'
import { on } from '@ember/modifier'
import { not } from 'ember-truth-helpers'
import { Collapser } from 'teacher-ui-client/components/collapser'

interface Signature {
  Element: HTMLDivElement
  Blocks: {
    header: [isCollapsed: boolean]
    content: [isCollapsed: boolean]
  }
}

export class ExpandBox extends Component<Signature> {
  @tracked isCollapsed: boolean = true

  @action
  toggleCollapsed() {
    this.isCollapsed = !this.isCollapsed
  }

  <template>
    <div data-test-expand-box class="block overflow-hidden rounded-lg" ...attributes>
      <div
        data-test-box-header
        class="block cursor-pointer select-none"
        role="button"
        {{on "click" this.toggleCollapsed}}
      >
        {{yield this.isCollapsed to="header"}}
      </div>
      <Collapser data-test-box-content @open={{not this.isCollapsed}}>
        {{yield this.isCollapsed to="content"}}
      </Collapser>
    </div>
  </template>
}
export default ExpandBox
